import { Validator } from "vee-validate";
import { BasicSelect } from "vue-search-select";
import CryptoJS from "crypto-js";
import VueElementLoading from "vue-element-loading";
import CONSTANT from "./../../../../shared/constants/constant";
import DatePicker from "vue2-datepicker";
import CustomExpandableTable from "../../../../shared/components/customExpandableTable";
import Pagination from "./../../../../shared/components/pagination";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Util from "./../../../../shared/util/util";
import Multiselect from "vue-multiselect";
import TripServices from "./../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service";
const moment = require("moment");
export default {
	name: "createMarketVehicleList",
	components: {
		BasicSelect,
		DatePicker,
		Multiselect,
		CustomExpandableTable,
		Pagination,
		Treeselect,
		VueElementLoading,
		TripServices,
	},
	props: ["selectedEditRowData"],
	data() {
		return {
			isLoading: false,
			isBasicInfoLoading: false,
			branchName: null,
			branchNameList: [],
			AdhocVehicleList: [],
			AdhocVehicleType: null,
			AvailaibleCapacity: 0,
			AdhocVehicleName: '',
			AdhocVehicleCapacity: 0,
			reasonadhocvehicle: null,
			addOtherReasonRemarks: null,
			RouteNamelist: [],
			routename: null,
			estimatedvehicleload: null,
			reasonadhocvehicleList: [
				{ id: "0", label: "Excess Pickup" },
				{ id: "1", label: "Excess Delivery" },
				{ id: "2", label: "Appointment Delivery" },
				{ id: "3", label: "ODA" },
				{ id: "4", label: "Other" },
			],
			vehiclecost: null,
			adhocvehiclenumber: '',
			reasonremarks: false,
			vehicleNoErr: "",
			uploadFile: '',
			filename: '',
			disableuplaodpoa: false,
			imagearray: [],
			panimagearray: [],
			requestid: '',
			vehiclevendorname: '',
			vehicleownerpan:'',
			vehicleownerpanError:'',
			pancardImage: '',
			panCardUpload: ''
		};
	},
	computed: {
		currentTabComponent: function () {
			this.componentKey += 1;
			this.uploadcsv = false;
			return this.currentTab.toLowerCase();
		},
	},
	async mounted() {
		var userdetailEncrypt = window.localStorage.getItem(
			"cargoAutoaccessuserdata"
		);
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.localuserid = userdetail.userid;
		this.userName = userdetail.email;
		this.defaultHubID = userdetail.hubID;
		this.HubId = userdetail.hubID[0];
		this.HubName = userdetail.currentHubName;
		this.todaysDate = Util.getCurrentDateOnly();
		this.maxDate = Util.getFutureDateOnly(30);
		this.userRoleFlag = userdetail.rolename[0] == "Admin" || userdetail.rolename[0] == "Operations Manager" || userdetail.rolename[0] == "Cargo Controlling Tower" ? 1 : 2;
		Promise.all([this.getVehicleModel(), this.getHubAccessList()])
	},
	created() {
		this.$root.$refs.createTripManagement = this;
	},
	methods: {
		showRequestedMarketVehicleList() {
			this.$emit("goBackToParent");
		},
		isNumber: function (evt) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (
				charCode > 31 &&
				(charCode < 48 || charCode > 57) &&
				charCode !== 46
			) {
				evt.preventDefault();
			} else {
				return true;
			}
		},
		isIntegerOnlty: function (evt) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode < 48 || charCode > 57) {
				evt.preventDefault();
			} else {
				return true;
			}
		},
		async getHubAccessList() {
			try {
				let InputPayload = {
					userid: this.localuserid
				}
				this.isLoading = true;
				let response = await TripServices.getHubAccessList(InputPayload)
				this.isLoading = false;
				let list = response.data.data.hubaccess
				list.forEach(el => {
					this.branchNameList.push({
						'value': el.HubID,
						'text': el.HubName
					})
					if (el.HubID == this.HubId) {
						this.branchName = {
							value: el.HubID,
							text: el.HubName
						}
						this.getRouteListing(el.HubID)
					}
				})
			} catch (err) {
				console.log(err)
			}
		},
		selectBranchName(branchname) {
			if (branchname) {
				this.routename=''
				this.getRouteListing(branchname.value);
			}
		},
		onSelectReason(event) {
			this.reasonremarks = true;
			//if (event.label.toLowerCase() == "other") {
			//	this.reasonremarks = true;
			//}
		},
		async getVehicleModel() {
			try {
				this.isLoading = true;
				let result = await TripServices.getVehicleType();
				let vehicletype = result.data.data;
				for (var i = 0; i < vehicletype.length; i++) {
					if(vehicletype[i].Capacity){
						this.AdhocVehicleList.push({
							id: vehicletype[i].VehicleId,
							label: `${vehicletype[i].VehicleName} (${vehicletype[i].Capacity})`,
							capacity: vehicletype[i].Capacity,
							vehiclename: vehicletype[i].VehicleName,
						});
					}
				}
				this.isLoading = false;
			} catch (err) {
				console.log(err);
			}
		},
		selectedVehicleType(vehicletype) {
			this.AdhocVehicleType = vehicletype.id
			this.AdhocVehicleName = vehicletype.vehiclename
			this.AdhocVehicleCapacity = vehicletype.capacity.toFixed(2)
			this.AvailaibleCapacity = Number(this.VehicleCapacity) - Number(this.assignedLoad)

		},
		async getRouteListing(hubid) {
			try {
				this.isLoading = true;
				this.RouteNamelist = [];
				let InputPayload = {
					HubId: [hubid],
				};
				let result = await TripServices.getRouteList(InputPayload);

				if (result.data.code == 200) {
					if (result.data.data.length) {
						let RouteList = result.data.data;
						for (var i = 0; i < RouteList.length; i++) {
							this.RouteNamelist.push({
								id: RouteList[i].id,
								label: RouteList[i].routename,
								$isDisabled: RouteList[i].disable,
							});
						}
					} else {
						this.$alertify.warning("Selected Hub has no Route added")
					}
				} else {
					this.$alert(result.data.message, "", "error");
				}
				this.isLoading = false;
			} catch (err) {
				this.isLoading = false;
				console.log(err);
			}
		},
		async FileUpload(event) {
			this.imageEvent = event
			this.uploadFile = event.target.files;
			this.imagearray = []
		},
		async UploadDocument(event) {
			try {
				this.isLoading = true
				let uploadFile = event.target.files;
				this.imagearray = []
				if (this.requestid == '' || this.requestid == null) {
					this.$alertify.error("Images could not be uploaded. Request ID is not Created");
					this.isLoading = false
				}
				else {
					let formData = new FormData();
					let size = 0
					for (let key in uploadFile) {
						if (key >= 0) {
							if (this.uploadFile[key].type != "image/jpeg" &&
								this.uploadFile[key].type != "image/jpg" && this.uploadFile[key].type != "image/png") {
								this.$alertify.error("Please upload only valid file format");
								this.isLoading = false
								return false
							}
						}
						size = this.uploadFile[key].size + size
						if (size > (1024 * 1024 * 6)) {
							this.$alert(`Uploaded file size is greater than 6000KB`, "", "error");
							this.isLoading = false
							return false
						} else {
							formData.append("file", this.uploadFile[key]);
						}
					}
					formData.append("requestid", this.requestid);
					let result = await TripServices.uploadProofOfApproval(formData)
					if (result.data.code == 200) {
						result.data.data.map(obj => {
							this.imagearray.push(obj.Location)
						})
						this.$alertify.success("Images uploaded successfully !");
						this.damagedocErr = ''
					}
					else {
						this.$alertify.error("Images could not be uploaded.");
						this.isLoading = false
					}
					this.isLoading = false
				}
			}
			catch (err) {
				this.isLoading = false
				console.log(err)
			}
		},
		async panCardFileUpload(event) {
			this.panimageEvent = event
			this.panCardUpload = event.target.files;
			this.panimagearray = []
		},
		async UploadPanDocument(event) {
			try {
				this.isLoading = true
				let panCardUpload = event.target.files;
				this.panimagearray = []
				if (this.requestid == '' || this.requestid == null) {
					this.$alertify.error("Images could not be uploaded. Request ID is not Created");
					this.isLoading = false
				}
				else {
					let formData = new FormData();
					let size = 0
					for (let key in panCardUpload) {
						if (key >= 0) {
							if (this.panCardUpload[key].type != "image/jpeg" &&
								this.panCardUpload[key].type != "image/jpg" && this.panCardUpload[key].type != "image/png") {
								this.$alertify.error("Please upload only valid file format");
								this.isLoading = false
								return false
							}
						}
						size = this.panCardUpload[key].size + size
						if (size > (1024 * 1024 * 6)) {
							this.$alert(`Uploaded file size is greater than 6000KB`, "", "error");
							this.isLoading = false
							return false
						} else {
							formData.append("file", this.panCardUpload[key]);
						}
					}
					formData.append("requestid", this.requestid);
					let result = await TripServices.uploadProofOfApproval(formData)
					console.log("result ---------",result);
					if (result.data.code == 200) {
						result.data.data.map(obj => {
							this.panimagearray.push(obj.Location)
							console.log("Panimage Array ---------",this.panimagearray);
						})
						this.$alertify.success("Images uploaded successfully !");
						this.damagedocErr = ''
					}
					else {
						this.$alertify.error("Images could not be uploaded.");
						this.isLoading = false
					}
					this.isLoading = false
				}
			}
			catch (err) {
				this.isLoading = false
				console.log(err)
			}
		},
		async createRequest() {
			try {
				let inputPayload = {}
				let imagepayload = {}
				let panimagepayload = {}
				let uploadformData = new FormData();
				this.uploadflag = false;
				this.pancardUploadflag = false;
				if (this.adhocvehiclenumber != '') {
					if (this.adhocvehiclenumber.trim().match(/^[A-Z]{2}[ ]?[0-9]{2}[ ]?[A-Z]{1,3}[ ]?[0-9]{4}$/)) {
						inputPayload.vehiclenumber = this.adhocvehiclenumber.trim();
						this.vehicleNoErr = "";
					} else {
						this.vehicleNoErr = "Vehicle Number Format Is Incorrect";
						return false;
					}
				}
				if (!this.branchName) {
					this.$alertify.error("Please select Branch Name");
					return false;
				}
				if(!this.vehicleownerpan || !this.vehicleownerpan.trim().match(/^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}/)){
					this.vehicleownerpanError = "Please enter valid format of PAN"
					return false;
				}else{
					inputPayload.vehicleownerpan = this.vehicleownerpan
					this.vehicleownerpanError = "";
				}
				if (!this.AdhocVehicleType) {
					this.$alertify.error("Please select vehicle type");
					return false;
				}
				if (!this.estimatedvehicleload) {
					this.$alertify.error("Please Enter the Estimated Vehicle Load");
					return false;
				}
				if (!this.reasonadhocvehicle) {
					this.$alertify.error("Please select the Ad-hoc Vehicle Reason");
					return false;
				} else if (this.reasonadhocvehicle.label.toLowerCase() == 'other') {
					if (!this.addOtherReasonRemarks) {
						this.$alertify.error("Please Enter the Other reasons remarks");
						return false;
					}
				}
				if (!this.vehiclecost) {
					this.$alertify.error("Please enter the vehicle cost");
					return false;
				}
				if (this.uploadFile.length) {
					this.uploadflag = true
					uploadformData.append("file", this.uploadFile);
				}
				if (this.routename) {
					inputPayload.routename = this.routename.label
					inputPayload.routeid = this.routename.id
				}
				if(this.vehiclevendorname){
					inputPayload.vehiclevendorname = this.vehiclevendorname
				}
				if (this.panCardUpload.length) {
					this.pancardUploadflag = true
					uploadformData.append("file",this.panCardUpload);
				}
				inputPayload.hubid = this.branchName.value
				inputPayload.hubname = this.branchName.text
				inputPayload.requestedvehicletype = this.AdhocVehicleName
				inputPayload.reasonadhocvehicle = this.reasonadhocvehicle.label
				inputPayload.requestedvehiclecost = this.vehiclecost
				inputPayload.requestedvehicleload = this.estimatedvehicleload
				inputPayload.vehiclenumber = this.adhocvehiclenumber
				inputPayload.otherreason = this.addOtherReasonRemarks
				inputPayload.lastmodifiedby = this.userName
				inputPayload.vehiclecapacity = this.AdhocVehicleCapacity
				this.isBasicInfoLoading = true;
				let approvalInputpayload ={}
				approvalInputpayload.hubid = this.branchName.value 
				let checkApprovalMapping = await TripServices.getApprovalHierarchyUsers(approvalInputpayload);
				if(checkApprovalMapping.data.data.length ==0){
					this.isBasicInfoLoading = false;
					this.$alertify.error(`Kindly Add Market Vehicle Request Approval flow to create request.`);
				}else{
					let result = await TripServices.saveMarketVehicleRequest(inputPayload)
					if (result.data.code == 200) {
						this.requestid = result.data.data.requestid
						if(this.uploadflag){
							await this.UploadDocument(this.imageEvent)
							if(this.imagearray.length){
								imagepayload.requestid = this.requestid
								imagepayload.approvalimage = this.imagearray,
								TripServices.savePoofOfApprovalImage(imagepayload);
							}
						}
						console.log("this.pancardUploadflag--",this.pancardUploadflag)
						if(this.pancardUploadflag){
							await this.UploadPanDocument(this.panimageEvent)
							if(this.panimagearray.length){
								panimagepayload.requestid = this.requestid
								panimagepayload.pancardimage = this.panimagearray
								console.log("panimage array -----",panimagepayload,this.panimagearray)
								TripServices.savePoofOfApprovalImage(panimagepayload);
							}
						}
						this.isBasicInfoLoading = false;
						this.$alert(`You have successfully created Vehicle Request with ID ${result.data.data.requestid}.`, "", "success");
						this.$emit("goBackToParent")
					} else {
						this.isBasicInfoLoading = false;
						document.activeElement.blur();
						this.$alert(result.data.message, "", "error");
					}
				}
			} catch (error) {
				this.isBasicInfoLoading = false;
				this.$alertify.error(error);
			}
		},
		async resetRequest() {
			this.branchName = ""
			this.adhocvehiclenumber = ""
			this.routename = ""
			this.vehiclecost = ""
			this.addOtherReasonRemarks = ""
			this.reasonadhocvehicle = ""
			this.estimatedvehicleload = ""
			this.AdhocVehicleType = ""
			this.reasonremarks = false;
			this.imagearray = []
			this.uploadFile = ""
			this.panimagearray = []
			this.panCardUpload = ""
		}
	},
};



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/marketvehicleflm/createmarketvehiclerequest/createmarketvehiclerequest.component.js